import { Route } from '@angular/router';

export const objectSettingsRoutes: Route[] = [
  // {
  //   path: '',
  //   component: ObjectSettingsComponent,
  // },
];
